<template>
  <div class="container">
    <div class="row align-items-center profile-header">
      <div class="col-md-2 mb-3">
        <img
                :src="$auth.user.picture"
                alt="User's profile picture"
                class="rounded-circle img-fluid profile-picture"
        />
      </div>
      <div class="col-md text-center text-md-left">
        <h2>{{ $auth.user.name }}</h2>
        <p class="lead text-muted">{{ $auth.user.email }}</p>
      </div>
      <div class="col-md-12 text-center text-md-left">
        <h4>User Data</h4>
        <pre>{{ JSON.stringify($auth.user, null, 2) }}</pre>
      </div>

      <div class="col-md-12 text-center text-md-left" v-if="apiReady">
        <h4>API Test</h4>
        <div class="form-group">
          <label>Type</label>
          <select class="form-control" v-model="apiTestType" :disabled="apiTesting">
            <option value="availability_ensure">Availability Ensure</option>
            <option value="availability">Availability</option>
            <option value="whois">WhoIs</option>
          </select>
        </div>
        <div class="form-group">
          <label>Domain</label>
          <input type="text" class="form-control" v-model="apiTestDomain" :disabled="apiTesting">
        </div>
        <br />
        <button class="btn btn-primary" @click.prevent="apiTest" :disabled="apiTestDomain === '' || apiTesting">Get</button>
        <br />
        <pre v-if="apiTestResult !== false">{{ apiTestResult }}</pre>
      </div>
    </div>

  </div>
</template>

<script>
  import axios from "axios";
  import apiMixin from '../mixins/api.js';

  export default {
    mixins: [apiMixin],
    data(){
      return {
        apiTesting: false,
        apiTestType: 'availability',
        apiTestDomain: '',
        apiTestResult: false
      }
    },
    methods: {
      async apiTest(){
        this.apiTesting = true;
        this.apiTestResult = '';

        let url;
        switch(this.apiTestType){
          case 'availability_ensure':
            url = process.env.VUE_APP_API_URL + '/availability/ensure/' + this.apiTestDomain;
            break;
          default:
            url = process.env.VUE_APP_API_URL + '/' + this.apiTestType + '/' + this.apiTestDomain;
            break;
        }

        await axios.get(
                url,
                {headers: this.apiAuthHeaders})
                .then(response => {
                  this.apiTestResult = response.data;
                })
                .catch(error => {
                  this.apiTestResult = error.response.data;
                });

        this.apiTesting = false;
      }
    }
  }
</script>